<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2019-2020 (original work) Open Assessment Technologies SA ;
    export let data;

    $: label = data && data.label;
    $: span = data && data.span;
</script>

<style>
    span {
        color: var(--color-text-feedback);
        font-size: var(--fontsize-body-s);
        margin-top: 0.25rem;
        display: block;
    }
</style>

{#if label}
    <div aria-hidden="true">{data.data}</div>
    <div class="visually-hidden">{label}</div>
{:else}{data.data}{/if}
{#if span}<span>{span}</span>{/if}
